export function calculateHighlightedClassifiedsPrice(quantity: number): number {
    if (quantity <= 0) return 0;

    const basePrice = 50;
    let totalPrice = 0;

    for (let i = 1; i <= quantity; i++) {
        const discountPercentage = Math.min((i - 1) * 2.5, 25);
        const pricePerBoat = basePrice * (1 - discountPercentage / 100);
        totalPrice += pricePerBoat;
    }

    return Math.round(totalPrice);
}
